import React from "react";
import { useTitle, useMenu, useGetIdentity } from "@refinedev/core";
import { Menu, Space, Avatar, Typography } from "antd";
import { Link } from "react-router-dom";

type IUser = {
    id: number;
    name: string;
    avatar: string;
  };
const { Text } = Typography;

export const CustomSider: React.FC = () => {
    const Title = useTitle();
    const { menuItems, selectedKey } = useMenu();
    const { data: user } = useGetIdentity<IUser>();
    
    return (
        <>
            {Title && <Title collapsed={false} />}
            <Menu theme="dark" selectedKeys={[selectedKey]} mode="horizontal">
                {menuItems.map(({ icon, route, label }) => (
                    <Menu.Item key={route} icon={icon}>
                        <Link to={route ?? ""}>{label}</Link>
                    </Menu.Item>
                ))}

            </Menu>
            {/* <Space style={{ marginLeft: "8px" }} size="middle">
                {user?.name && <Text strong>{user.name}</Text>}
                {user?.avatar && <Avatar src={user?.avatar} alt={user?.name} />}
            </Space>                 */}
        </>
    );
};
